import { TypeInitProps, TypeRequest } from '../../types';
import { encryptParams } from '../../utils/index';
import { WEB_URL } from '../../utils/urls';
export default class BindAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @param {object} extra_params - extra params
   * @return {Promise} send result
   */
  sendCode = (params: {
    mobile: string;
    unbind_exist?: number;
    extra_params?: object;
  }) => {
    const { mobile, unbind_exist = 0, extra_params = {} } = params;
    const data = encryptParams(
      { mobile, type: 17, unbind_exist, ...extra_params },
      ['mobile', 'type', 'unbind_exist']
    );
    return this.request({
      url: WEB_URL.SEND_MOBILE_CODE,
      method: 'POST',
      data,
    });
  };
  /**
   * @param {string} mobile - the mobile about to bind
   * @param {string} code - the captcha
   * @param {string} password - if you want to set password
   * @param {number} unbind_exist - whether unbind forcely when the mobile is already bound to another account
   * @return {Promise} bind result
   */
  bindMobile = (
    params: {
      mobile?: string;
      code?: string;
      password?: string;
      verify_ticket?: string;
      unbind_exist?: number;
      extra_params?: object;
    } = {}
  ) => {
    const {
      mobile,
      code,
      password,
      verify_ticket,
      unbind_exist = 0,
      extra_params = {},
    } = params;
    const data = encryptParams(
      {
        mobile,
        code,
        password,
        verify_ticket,
        unbind_exist,
        type: 17,
        ...extra_params,
      },
      ['mobile', 'code', 'password', 'unbind_exist', 'type']
    );
    return this.request({
      url: WEB_URL.MOBILE_BIND,
      method: 'POST',
      data,
    });
  };

  /**
   * @param {string} email - the email about to bind
   * @return {Promise} bind result
   */
  sendEmailCode = (params: { email: string; extra_params?: object }) => {
    const { email, extra_params = {} } = params;
    const data = encryptParams(
      {
        email,
        type: 8,
        ...extra_params,
      },
      ['email', 'type']
    );
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} email - the email about to bind
   * @param {string} code - the captcha
   * @return {Promise} bind result
   */
  bindEmail = (params: {
    email: string;
    code: string;
    extra_params?: object;
  }) => {
    const { email, code, extra_params = {} } = params;
    const data = encryptParams({ email, code, ...extra_params }, [
      'email',
      'code',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.EMAIL_BIND,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} code - authorization code
   * @param {string} access_token - third-party authorization token
   * @param {string} access_token_secret - id token
   * @param {string} openid - third-party openid, used with access_token, only neccessary for google,facebook,google
   * @param {string} profile_key - third-party ticket that preserves information temporaily, used when the login progress is blocked
   * @return {Promise} bind result
   */
  bindAuth = (params: {
    platform_app_id: number;
    code?: string;
    access_token?: string;
    access_token_secret?: string;
    openid?: string;
    profile_key?: string;
    extra_params?: object;
  }) => {
    const {
      platform_app_id,
      code,
      access_token,
      access_token_secret,
      openid,
      profile_key,
      extra_params = {},
    } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.AUTH_BIND,
        method: 'POST',
        data: {
          platform_app_id,
          code,
          access_token,
          access_token_secret,
          openid,
          profile_key,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} platform - the platform about to unbind
   * @return {Promise} unbind result
   */
  unbindAuth = (params: { platform: string; extra_params?: object }) => {
    const { platform, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.AUTH_UNBIND,
        method: 'POST',
        data: {
          platform,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {number} platform_app_id - the app id of the third party about to bind
   * @param {string} profile_key - third-party ticket that preserves information temporaily
   * @return {Promise} switch result
   */
  switchBindAuth = (params: {
    platform_app_id: number;
    profile_key: string;
    extra_params?: object;
  }) => {
    const { platform_app_id, profile_key, extra_params = {} } = params;
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_URL.AUTH_SWITCH_BIND,
        method: 'POST',
        data: {
          platform_app_id,
          profile_key,
          ...extra_params,
        },
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} token - 扫tv端获取到的信息，url获取
   */
  changeQrcodeSuccess = (params: { token: string; extra_params?: object }) => {
    const { token, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.CHANGE_QRCODE_SUCCESS,
      method: 'POST',
      data: { token, ...extra_params },
    });
  };

  /**
   * @param {string} token - 扫tv端获取到的信息，url获取
   * @param {string} verify_ticket - 验证码正确后返回的票据
   */
  changeQrcodeComfirm = (params: {
    verify_ticket: string;
    token: string;
    extra_params?: object;
  }) => {
    const { token, verify_ticket, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.CHANGE_QRCODE_CONFIRM,
      method: 'POST',
      data: { token, verify_ticket, ...extra_params },
    });
  };
}
